import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tourHome relative h-full" }
const _hoisted_2 = {
  key: 1,
  class: "absolute z-1 inset-0 flex items-center justify-center"
}
const _hoisted_3 = { class: "text-gray-500 w-40" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ParallelEditErrorModal = _resolveComponent("ParallelEditErrorModal")!
  const _component_TourOverview = _resolveComponent("TourOverview")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ParallelEditErrorModal),
    (_ctx.store?.state?.OrderStore?.tours.length)
      ? (_openBlock(), _createBlock(_component_TourOverview, {
          key: 0,
          tours: _ctx.store?.state?.OrderStore?.tours
        }, null, 8, ["tours"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("tour.empty")), 1)
        ]))
  ]))
}